export interface IServiceError {
  error: {
    message: string
  }
}
export function isServiceError(obj: unknown): obj is IServiceError {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'error' in obj &&
    typeof obj.error === 'object' &&
    obj.error !== null &&
    'message' in obj.error &&
    typeof obj.error.message === 'string'
  )
}
